import React from 'react'
import CodeMirror from 'core/components/codeMirror/CodeMirror'
import withFormContext from 'core/components/validatedForm/withFormContext'

export default withFormContext(CodeMirror)
